function retrieveMissingSizes(data) {
    let animations = data.assets.animations;
    if (!animations) return;

    let uuids = Object.keys(animations).filter(uuid => !('fileSize' in animations[uuid]));
    retrieve(data, uuids);
}

function retrieve(data, uuids, index = 0) {
    if (index === uuids.length) return;

    let uuid = uuids[index];
    let animData = data.assets.animations[uuid];

    const token = localStorage.getItem("jwt");
    $.ajax({
        url: (window.COOBO ? "/api" : "") + "/asset/getsize/",
        type: "POST",
        dataType: "json",
        data: { files: [animData.path.substring(1)] },
        beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + token);
        },
        success: size => {
            animData.fileSize = size;
            retrieve(data, uuids, index+1);
        },
        error: (xhr, status, err) => {
            console.error(err);
            retrieve(data, uuids, index+1);
        },
    });
}

export default retrieveMissingSizes;
